import { RISK_RATING_PRIMARIES } from "@/common/constants/controlRisks/risks";

export const RISK_SUMMARY_TYPE_OVERVIEW_ID =
  "788ab9a7-793e-415d-9d49-99feb0a7ec26";
export const RISK_SUMMARY_TYPE_SECURITY_RISK_ID =
  "8c66d011-cfa1-4b09-be6f-43f633efe1d7";
export const RISK_SUMMARY_TYPE_PROFILE_ID =
  "f5cb93b6-90f4-455e-b7c5-d975711ef78d";
export const RISK_SUMMARY_TYPE_SCENARIO_ID =
  "49488785-b7ab-4d29-b8f7-80ebc13f59f0";

export const RISK_SUMMARY_TYPES = [
  {
    label: "Overview",
    id: RISK_SUMMARY_TYPE_OVERVIEW_ID,
    isCyber: false,
    isGrd: false,
    riskRatingPrimary: 1,
  },
  {
    label: "Political Risk",
    id: "05b4805c-3317-43da-a9cc-c0ab8eac40ee",
    isCyber: false,
    isGrd: false,
    riskRatingPrimary: RISK_RATING_PRIMARIES.political,
  },
  {
    label: "Operational Risk",
    id: "44edece2-7d99-4403-a702-11b603d7b50b",
    isCyber: false,
    isGrd: false,
    riskRatingPrimary: RISK_RATING_PRIMARIES.operational,
  },
  {
    label: "Security Risk",
    id: RISK_SUMMARY_TYPE_SECURITY_RISK_ID,
    isCyber: false,
    isGrd: true,
    riskRatingPrimary: RISK_RATING_PRIMARIES.security,
  },
  {
    label: "Cyber",
    id: "ac19dbe1-cbe4-49b5-9347-356cf4b6128f",
    isCyber: true,
    isGrd: false,
    riskRatingPrimary: RISK_RATING_PRIMARIES.cyber,
  },
  {
    label: "Profile",
    id: RISK_SUMMARY_TYPE_PROFILE_ID,
    isCyber: false,
    isGrd: true,
    riskRatingPrimary: null,
  },
  {
    label: "Scenarios",
    id: RISK_SUMMARY_TYPE_SCENARIO_ID,
    isCyber: false,
    isGrd: false,
    riskRatingPrimary: null,
  },
];
